import { FC, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { resolveItemImage } from "@/helpers/itemImage"
import { deriveQuickSlotsView } from "@/modals/constructor/inventory/InventoryModal/helpers"
import styles from "./QuickSlotBelt.module.scss"
import { IQuickSlotBeltProps } from "./types"

export const QuickSlotBelt: FC<IQuickSlotBeltProps> = ({
  quickSlots,
  items,
  onItemClick
}) => {
  const { t } = useTranslation("inventory")

  const view = useMemo(
    () => deriveQuickSlotsView(quickSlots, items),
    [quickSlots, items]
  )

  const handleOpen = (firstInstanceId: string) => {
    const target = items.find((stack) => stack.id === firstInstanceId)
    if (target) {
      onItemClick(target)
    }
  }

  return (
    <div
      className={styles.QuickSlotBelt}
      style={{ gridTemplateColumns: `repeat(${view.length}, 1fr)` }}
    >
      {view.map((cell, index) => {
        if (!cell) {
          return <div key={index} className={styles.QuickSlotBelt_cellEmpty} />
        }
        const image = resolveItemImage(cell.definitionCode)
        const name = t(`item.${cell.definitionCode}.name`)
        return (
          <button
            key={index}
            type="button"
            className={styles.QuickSlotBelt_cell}
            onClick={() => handleOpen(cell.firstInstanceId)}
          >
            {image ? (
              <img src={image} alt={name} />
            ) : (
              <span className={styles.QuickSlotBelt_fallback} />
            )}
            <span className={styles.QuickSlotBelt_qty}>
              ×{cell.totalQuantity}
            </span>
          </button>
        )
      })}
    </div>
  )
}
